import React, { Component, Fragment } from "react"
import actions from "./actions/root_action"
import { connect } from "react-redux"
import { withNamespaces } from "react-i18next"
import { compose } from "redux"
import "../../i18n"
import moment from 'moment'
import Modal from '../../common/components/modal_dialog/modal_wrapper_component'
import "./main_container.scss"
import SearchForm from "./search_form"
import lozad from 'lozad'

const imgdir = '/assets/image/special/zenkokuryokoshien'

export class Main extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isShowCode: false
    }

    moment.locale(languageHelper.pageLocale)
  }

  async componentDidMount() {
    const observer = lozad()
    observer.observe()
  }

  render() {
    return (
      <Fragment>
        <div styleName="container">
          <h1>
            <img className="lozad" data-src={`${imgdir}/lp-eyecatch-pc-v2.png`} styleName="eye-catch" alt=""/>
            <img className="lozad" data-src={`${imgdir}/lp-eyecatch-sp-v2.png`} styleName="eye-catch sp-only" alt=""/>
          </h1>
          <div styleName="block">
            <h2 style={{ marginTop: 0, textAlign: "center", color: "#004C8C" }}>全国旅行支援対象の宿泊施設を探す</h2>
            <SearchForm />
            <div style={{fontSize: 14, lineHeight: 1.3, marginTop: 8, textAlign: "center"}}>
              ※全国旅行支援をご利用の前に必ず各都道府県の利用条件に同意の上ご利用ください。<br/>
              ※各都道府県に割り当てられる予算の上限に達し次第終了いたします。あらかじめご了承ください。<br/>
              <a
                href="https://www.mlit.go.jp/kankocho/page06_000261.html"
                target="_blank"
                style={{display: "inline-block", marginTop: 8, textDecoration: "underline"}}
              >
                {"全国旅行支援　都道府県連絡先一覧 | 観光庁"}
              </a>
            </div>
          </div>
          <section>
            <h2 styleName="section-header">全国旅行支援とは？</h2>
            <p styleName="block" style={{margin: 0}}>
              「全国旅行支援」とは、政府が実施する全国を対象とした観光需要喚起策です。<br/>
              旅行代金の20％相当が割引されます。（1人1泊あたり、割引上限額については、交通付旅行商品は5,000円、その他は3,000円）また、現地で使えるクーポン券（平日は2,000円分、休日1,000円分）が宿泊施設チェックイン時に渡されます。割引適用ルールなどの詳細は各都道府県のページをご確認ください。
            </p>
          </section>
          <section>
            <h2 styleName="section-header">割引のしくみ</h2>
            <div styleName="block">
              <table styleName="waribiki">
                <tbody>
                  <tr>
                    <th>割引率</th>
                    <td>20%</td>
                  </tr>
                  <tr>
                    <th>期間</th>
                    <td>
                      令和5年1月10日（火）宿泊～
                      <div styleName="note">
                        ※対象期間は都道府県により異なりますので、必ず各都道府県の条件をご確認ください。
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      割引上限額<br/>
                      <span styleName="small">(１人１泊あたり)</span>
                    </th>
                    <td>
                      交通付き宿泊 5,000円、宿泊 3,000円
                      <div styleName="note">
                        最低旅行代金（１人１泊あたり）平日：3,000円、休日：2,000円<br/>
                        子供や幼児も１名としてカウントされます
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      地域クーポン<br/>
                      <span styleName="small">(１人１泊あたり)</span>
                    </th>
                    <td>
                      平日 2,000円<br/>
                      休日 1,000円
                      <div styleName="note">
                        宿泊日とその翌日がともに休日（土曜・日曜・祝日）の場合には、その宿泊は「休日」として扱い、それ以外を「平日」として扱います。
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>対象</th>
                    <td>
                      全国の都道府県からの旅行
                      <div styleName="note">
                        ※各都道府県から申し出があった場合、当該都道府県を目的地とする旅行を除外
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>ご旅行にお持ちいただく書類</th>
                    <td>
                      本人確認書類
                      <div styleName="note">
                        ※チェックイン時に必ずご提示ください<br/>
                        ※該当書類の詳細は各都道府県の情報をご確認ください
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>その他条件</th>
                    <td>
                      ・日本国内に居住する旅行者<br/>
                      ・ひとつの旅程において７泊まで
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          <section styleName="cpn-details">
            <h2 styleName="section-header">全国旅行支援の注意事項</h2>
            <div styleName="block">
              <h3>本人確認・居住地確認について</h3>
              <p>
                本クーポンのご利用にあたっては、チェックイン時に宿泊者全員の本人確認・居住地確認が行われます。予めご準備の程よろしくお願いいたします。<br/>
                本人確認・居住地確認に必要な書類は、各都道府県の規程をご確認ください。
              </p>
              <br/>
              <p>
                ＜本人確認書類例＞<br/>
                マイナンバーカード、運転免許証、運転経歴証明書、旅券（パスポート）、在留カード、特別永住者証明書、海技免状等国家資格を有することを証明する書類、障害者手帳等福祉手帳、船員手帳、戦傷病者手帳、国または地方公共団体の機関が発行した身分証明書 など
              </p>

              <h3>感染状況悪化(ステージ)によるクーポン停止について</h3>
              <p>
                新型コロナウィルスの感染状況が悪化すると、各自治体の判断により事業の停止措置がとられる可能性があります。事業停止後に予約済みの宿泊予約が割引適用対象外になることや、取得済みのクーポンが利用できなることもありますので、予めご了承ください。
              </p>
            </div>
          </section>
        </div>
        <Modal />
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    login: state.login,
    language: state.language,
    modal: state.modal,
    search: state.search
  }
}

const mapDispatchToProps = (dispatch, state) => {
  return {
    actions: actions(dispatch)
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNamespaces()
)(Main)
